import React from "react";

interface NotificationSettingsErrorProps {
  error: string | null;
}

export const NotificationSettingsError: React.FC<
  NotificationSettingsErrorProps
> = ({ error }) => {
  if (!error) return null;
  return <div className="text-error p-2">{error}</div>;
};
